import { useCallback, useEffect, useRef, useState } from "react";
import { Toast, Modal } from "antd-mobile";
import { ethers } from "ethers";
import BigNumber from 'bignumber.js'
import { WalletContext } from "./useWallet";
import { hideAccount } from "../../utils/utils";
import { ENV } from "../../utils/constants";
import { useIntl } from "react-intl";

//  type
// mount_equip mount_card sync set_track
// unmount_equip unmount_card compose tranfer
// claim_lottery
// claim_profit harvest_profit_by_day harvest_profit_by_date_range
export default function WalletProvider({ children }) {
  const [provider, setProvider] = useState();
  const [chainId, setChainId] = useState();
  const [myAccount, setMyAccount] = useState();
  const [maticBalance, setMaticBalance] = useState({price:0,uiString:'--'})
  const ethereum = window.ethereum || (window.bitkeep && window.bitkeep.ethereum);
  const intl = useIntl();
  useEffect(() => {
    toLogin();
  }, []);

  const bindEvents = () => {
    ethereum.on("accountsChanged", (accounts) => {
      Toast.clear();
      Modal.clear();
      if (window.location.pathname !== "/") {
        window.location.href = "/";
        return;
      }
      setMyAccount("");
      console.log("accountsChanged");
      toLogin();
    });
    ethereum.on("chainChanged", (chainId) => {
      Toast.clear();
      Modal.clear();
      if (window.location.pathname !== "/") {
        window.location.href = "/";
        return;
      }
      setMyAccount("");
      console.log("chainChanged");
      toLogin();
    });
  };
  const toLogin = async () => {
    if (!ethereum) {
      Toast.show({
        content: intl.formatMessage({ id: "common.install_metamask" }),
        icon: "fail",
        maskClickable: false,
      });
      return;
    } else {
      const provider = new ethers.providers.Web3Provider(
        ethereum
      );
      setProvider(provider);

      getAccount(provider)
        .then(async (accounts) => {
          console.log("getAccount start");
          const chainId = await getChain();
          const c = ENV === "prod" ? "0x89" : "0x13881";
          console.log(chainId);
          if (chainId !== c) {
            //0x89   // 0x13881
            Toast.show({
              content: intl.formatMessage({ id: "common.chain_error" }),
              icon: "fail",
              maskClickable: false,
            });
            if (window.location.pathname !== "/") {
              window.location.href = "/";

              return;
            }
          }
          const myAccount =  accounts[0];

          const code = await  provider.getCode(myAccount)
          const isContract = code !== "0x"
          const uiAccount = hideAccount(myAccount,4,3);

          setMyAccount({ account: myAccount, uiAccount,isContract });
          bindEvents();
        })
        .catch((e) => {
          console.log(e)
          let text =
            intl.formatMessage({ id: "common.account_error" }) + e.message;
          if (e.code === -32002) {
            text = intl.formatMessage({
              id: "common.account_connect_wallet",
            });
          }
          Toast.show({
            content: text,
            icon: "fail",
            // duration:0,
            maskClickable: false,
          });
        });
    }
  };
  const getAccount = (provider) => {
    return provider.send("eth_requestAccounts", []);
  };



  const getAccountBalance = async () => {
    const balance= await provider.getBalance(myAccount.account,'latest' );
    let etherString = ethers.utils.formatEther(balance);
    etherString = new BigNumber(etherString).toFixed(2)
    console.log('etherString',etherString)
    setMaticBalance({price:balance,uiString:etherString})
    return etherString
  };
  const getBlock = () => {
    return provider.getBlock();
  };
  const getChain = () => {
    return ethereum
      .request({
        method: "eth_chainId",
      })
      .then((chainId) => {
        console.log("chainId", chainId);
        setChainId(chainId);
        return chainId;
      });
  };
  return (
    <WalletContext.Provider
      value={{
        provider,
        myAccount,
        toLogin,
        getChain,
        chainId,
        getBlock,
        getAccountBalance,
        maticBalance
      }}
    >
      {children}
    </WalletContext.Provider>
  );
}
